var Request = require('../helper/request');

function Permission(app, userId){
  var self = this;
  self.userId = userId;
  self.request = new Request(app);

  self.routes = {
    show: {
      url: '/iam/access/control/'+self.userId+'/permission_set_grant',
      method: "GET"
    },
    create: {
      url: '/iam/access/control/'+self.userId+'/permission_set_grant',
      method: "POST"
    },
    delete: {
      url: '/iam/access/control/'+self.userId+'/permission_set_grant',
      method: "DELETE"
    }
  }
}

Permission.prototype.show = function(){
  var self = this;
  return self.request.get(self.routes.show.url);
}

Permission.prototype.create = function(data){
  var self = this;
  return self.request.post(self.routes.create.url, {
    permission_set_grant: data
  });
}

Permission.prototype.delete = function(data){
  var self = this;
  return self.request.post(self.routes.delete.url, {
    permission_set_grant: data
  });
}

// Permission.prototype.get = function(key){
//   var self = this;
//   var permissions = self.storage.local.getItem("permissions");
//   permissions = JSON.parse(permissions).p;
//   return Object.keys(permissions).map(function(i){
//     if(/key/i.test(permissions[i].name)){
//       console.log(permissions[i].name);
//     }
//   });
// }

module.exports = Permission;
